import axios from '@axios'

export default {
  namespaced: true,
  state: {
    helper: {
      id: null,
      title: '',
      conteudo: '',
      ativo: 1,
      target: '',
      placement: '',
      sequencia: '',
      type_helper: '',
      enable_scrolling: 0,
      hightlight: 0,
      is_manual: 0,
    },
    isOpenHelperTour: false,
    typeHelperTour: '',
    stepsHelper: [],
    tableHelperTour: [],
    helpersFilters: [],
  },
  getters: {
    isOpenHelperTour: state => state.isOpenHelperTour,
    typeHelperTour: state => state.typeHelperTour,
    getTableHelperTour: state => state.tableHelperTour,
    getHelper: state => state.helper,
    getHelpersFilters: state => state.helpersFilters,
  },
  mutations: {
    SET_IS_OPEN_HELPER_TOUR(state, payload) {
      state.isOpenHelperTour = payload
    },
    SET_TYPE_HELPER_TOUR(state, payload) {
      state.typeHelperTour = payload
    },
    SET_STEPS_HELPER(state, payload) {
      state.stepsHelper = payload
    },
    SET_TABLE_HELPER_TOUR(state, payload) {
      state.tableHelperTour = payload
    },
    SET_HELPER(state, payload) {
      state.helper = payload
    },
    SET_HELPERS_FILTERS(state, payload) {
      state.helpersFilters = payload
    },
  },
  actions: {
    async findAll({ commit }, queries = {}) {
      let query = queries ? '?' : ''
      query += Object.keys(queries).map(key => {
        if (queries[key] === '' || queries[key] === null) {
          // eslint-disable-next-line no-param-reassign
          delete queries[key]
        } else {
          return `${key}=${queries[key]}`
        }

      }).join('&')
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        await axios.get(`/helper-tour${query}`)
          .then(response => {
            commit('SET_TABLE_HELPER_TOUR', response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async create({ dispatch }, { data }) {
      return new Promise(async (resolve, reject) => {
        await axios.post('/helper-tour', data)
          .then(resp => {
            dispatch('findAll')
            dispatch('restartTours')
            resolve(resp.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async update({ dispatch }, { data, id }) {
      return new Promise(async (resolve, reject) => {
        await axios.put(`/helper-tour/${id}`, data)
          .then(resp => {
            dispatch('findAll')
            dispatch('restartTours')
            resolve(resp.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async deleted({ dispatch }, { id }) {
      return new Promise(async (resolve, reject) => {
        await axios.delete(`/helper-tour/${id}`)
          .then(resp => {
            dispatch('findAll')
            dispatch('restartTours')
            resolve(resp.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    toogleIsOpenHelperTour({ state, commit }) {
      commit('SET_IS_OPEN_HELPER_TOUR', !state.isOpenHelperTour)
    },
    startHelperTour({ state, commit }) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        await axios.get(`/helper-tour?type=${state.typeHelperTour}`)
          .then(response => {
            commit('SET_STEPS_HELPER', response.data)
            commit('SET_IS_OPEN_HELPER_TOUR', true)
            resolve(state.isOpenHelperTour)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    scrollToElementeTour({ state }, payload) {
      return new Promise((resolve, reject) => {
        const element = document.getElementById(elementId)
        if (element) {
          const topOffset = element.offsetTop - 100 // 100px de deslocamento
          window.scrollTo({ top: topOffset, behavior: 'smooth' })
        }
        resolve(true)
      })
    },
    findByTypeHelperTour({ commit }, { typeHelperTour }) {
      return new Promise(async (resolve, reject) => {
        await axios.get(`/helper-tour?type=${typeHelperTour}&transform=1`)
          .then(response => {
            commit('SET_HELPERS_FILTERS', response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    restartTours({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_IS_OPEN_HELPER_TOUR', false)
        commit('SET_TYPE_HELPER_TOUR', null)
        commit('SET_STEPS_HELPER', [])
        resolve(true)
      })
    },
    addBeforeStep({ state, commit }, { value, type, beforeStep }) {
      if (state.stepsHelper.length === 0) return
      const steps = state.stepsHelper
      const alterStep = steps.find(step => {
        if (type === 'title') return step.header[type] === value
        return step[type] === value
      })

      if (alterStep && typeof alterStep !== 'undefined') {
        alterStep.before = beforeStep
      }
      commit('SET_STEPS_HELPER', steps)
    },
  },
}
